import { FC } from "react";
import { MediaProps } from "../types/Article.types";
import { HeroImageWrapper } from "./Hero.styled";
import HeroSelector from "./HeroSelector";

interface Props {
  type: string;
  isVideo: boolean;
  hero: MediaProps;
  isHeroOverride?: boolean;
  dailyMotion?: boolean;
}

const Hero: FC<Props> = ({ type, dailyMotion, hero, isHeroOverride }) => {
  if (type === "Commercial") {
    return null;
  }
  if (dailyMotion) {
    return null;
  }
  return (
    <div>
      <HeroImageWrapper>
        <HeroSelector
          isHeroOverride={isHeroOverride}
          hero={hero}
          isHero={false} // @todo revert to true when ready for release
        />
      </HeroImageWrapper>
    </div>
  );
};

export default Hero;
